import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const BillingConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.BillingInfoContainer>
        <Styles.Card>
          <Skeleton variant="text" width={120} height={24} />
          <Skeleton variant="rounded" width="100%" height={180} />
        </Styles.Card>
        <Styles.Card>
          <Skeleton variant="text" width={160} height={24} />
          <Styles.Field>
            <Skeleton variant="text" width={100} height={16} />
            <Skeleton variant="text" width="60%" height={20} />
          </Styles.Field>
          <Styles.Field>
            <Skeleton variant="text" width={100} height={16} />
            <Skeleton variant="text" width="60%" height={20} />
          </Styles.Field>
          <Styles.Field>
            <Skeleton variant="text" width={100} height={16} />
            <Skeleton variant="text" width="60%" height={20} />
          </Styles.Field>
          <Styles.Field>
            <Skeleton variant="text" width={100} height={16} />
            <Skeleton variant="text" width="60%" height={20} />
          </Styles.Field>
        </Styles.Card>
      </Styles.BillingInfoContainer>

      <Divider />

      <Styles.SubsidiaryContainer>
        <Skeleton variant="text" width={280} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="80%" height={20} />
        <Styles.SubsidiaryGrid>
          <Styles.InfoCard>
            <Skeleton variant="text" width={120} height={24} />
            <Styles.InfoContent>
              <Styles.Field>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="text" width="60%" height={20} />
              </Styles.Field>
              <Styles.Field>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="text" width="60%" height={20} />
              </Styles.Field>
              <Styles.Field>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="text" width="60%" height={20} />
              </Styles.Field>
            </Styles.InfoContent>
          </Styles.InfoCard>
          <Styles.InfoCard>
            <Skeleton variant="text" width={120} height={24} />
            <Styles.InfoContent>
              <Styles.Field>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="text" width="60%" height={20} />
              </Styles.Field>
              <Styles.Field>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="text" width="60%" height={20} />
              </Styles.Field>
              <Styles.Field>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="rounded" width={120} height={36} />
              </Styles.Field>
            </Styles.InfoContent>
          </Styles.InfoCard>
        </Styles.SubsidiaryGrid>
      </Styles.SubsidiaryContainer>
    </Styles.Container>
  )
}

export default BillingConfigurationSkeleton
